import { useQuery } from '@tanstack/react-query';

import { getAdminV1OrgSettings } from '@nucleus-commerce/api-client/admin';

import { authKeys } from './auth-keys';

/**
 * Whether the organisation requires two-factor, from /org/settings. Idle without `settings.read`
 * (the backend would answer 403) and null until known; the Security page then falls back to the
 * `twoFactorRequired` flag on /me, which only covers unenrolled accounts.
 */
export function useOrganizationTwoFactorRule(enabled: boolean): boolean | null {
  const query = useQuery({
    queryKey: authKeys.organizationTwoFactorRule(),
    queryFn: () => getAdminV1OrgSettings(),
    enabled,
    staleTime: 5 * 60_000,
    meta: { silentError: true },
  });
  return query.data ? query.data.security.requireTwoFactor : null;
}
